export default __webpack_public_path__ + "static/media/Delivery-bro.ef186a34.png";